import { render, staticRenderFns } from "./ReportingForm.vue?vue&type=template&id=09becb51&scoped=true&"
import script from "./ReportingForm.vue?vue&type=script&lang=js&"
export * from "./ReportingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09becb51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09becb51')) {
      api.createRecord('09becb51', component.options)
    } else {
      api.reload('09becb51', component.options)
    }
    module.hot.accept("./ReportingForm.vue?vue&type=template&id=09becb51&scoped=true&", function () {
      api.rerender('09becb51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/ReportingForm.vue"
export default component.exports